<div
  #editorContainer
  class="editor-container"
  [style.height]="height">
</div>